<template>
  <div>
    <nav class="bar bar-nav">
      <a class="icon icon-left pull-left" @click="goBack"></a>
      <h1 class="title">发票抬头管理</h1>
    </nav>
    <div class="content">
      <div class="list-block media-list">
        <ul>
          <li v-for="(invoice, index) in invoiceInfo" :id="index">
            <div class="item-content">
              <div class="item-inner">
                <div class="item-title-row">
                  <div class="item-title">{{invoice.enterpriseName}}</div>
                </div>
                <div class="row" style="height: 40px;margin-top: 5px;">
                  <div class="col-50 " style="float: left;width: 40%;margin-top: 5px;">
                    <div class="item-title label" style="width: 100PX;font-size: 0.7rem">设为默认</div>
                    <div class="item-input" style="margin-top: -38px;margin-left: 46%;line-height: 40px;">
                      <label class="label-checkbox">
                        <input type="radio" name="my-radio" @change="submit(invoice, $event)" :checked="invoice.isDefault">
                        <div class="item-media" style="margin-top: 0.6rem;margin-left: 1%;position: relative">
                          <i class="icon icon-form-checkbox"></i>
                        </div>
                      </label>
                    </div>
                  </div>
                  <div class="col-50" style="float: right;width: 20px">
                    <a class="item-media" @click="delInvoice(invoice)">
                      <div class="item-input">
                        <span class="icon icon-remove"></span>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div class="content-block">
        <router-link :to="{name: 'addInvoiceTitle' , query: {from: from}, params:{order: $route.params.order}}" style="width: 100%;" :disabled="count>2" :class="{'disabled':count>2}" class="button button-big button-fill">
          新增发票抬头
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapState, mapMutations} from 'vuex'
  import $ from 'jquery'

  export default {
    created () {
      this.getData()
    },
    mounted () {
    },
    data () {
      return {
        invoiceInfo: [],
        from: ''
      }
    },
    beforeRouteEnter (to, from, next) {
      next(vm => {
        // 若从编辑地址界面返回到本页面，取query中记录的from值，否则取from界面的名称，
        vm.from = from.query.from ? from.query.from : from.name
      })
    },
    computed: {
      ...mapState([
        'sessionInfo'
      ]),
      'count': function () {
        return this.sessionInfo.invoiceTitle.length
      }
    },
    watch: {
    },
    methods: {
      ...mapMutations([
        'INVOICE_TITLE'
      ]),
      submit (inv, e) {
        console.log(inv.isDefault)
        let _this = this
        let isDefault = e.target.checked
        _this.gcapi('gcwwwifc/createOrUpdateInvoiceTitle', {
          'IsDefault': (isDefault === false) ? 0 : 1,
          'EnterpriseNo': inv.enterpriseNo
        }).then((response) => {
          if (response.body.code === 0) {
            _this.gcapi('gcwwwifc/getUserProfile?ProfileType=2').then((res) => {
              _this.INVOICE_TITLE(res.body.result)
              _this.invoiceInfo = res.body.result
            })
            $.toast('修改成功')
          } else if (response.body.code === 1) {
          }
        })
      },
      delInvoice (inv) {
        var _this = this
        _this.gcapi('gcwwwifc/deleteInvoiceTitle', {
          'EnterpriseNo': inv.enterpriseNo
        }).then((response) => {
          if (response.body.code === 0) {
            _this.gcapi('gcwwwifc/getUserProfile?ProfileType=2').then((res) => {
              _this.INVOICE_TITLE(res.body.result)
              _this.invoiceInfo = res.body.result
            })
            $.toast('删除成功')
          } else {
          }
        })
      },
      getData () {
        let _this = this
        _this.gcapi('gcwwwifc/getUserProfile?ProfileType=2').then((response) => {
          _this.INVOICE_TITLE(response.body.result)
          _this.invoiceInfo = response.body.result
        })
      },
      goBack () {
        // 回到orderContentConfirm时，不传param，只有回到orderContent界面，才需传params
        if (this.from === 'orderContentConfirm') {
          this.$router.replace({name: 'orderContentConfirm'})
        } else if (this.from === 'orderContent') {
          this.$router.replace({name: 'orderContent', params: {order: this.$route.params.order}})
        } else {
          this.$router.push({name: 'me'})
        }
      }
    }
  }

</script>

<style>

</style>



// WEBPACK FOOTER //
// InvoiceTitle.vue?6672d588